import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TransactionDualApprovalService } from 'src/app/fednow/service/http/transaction-dual-approval.service';

@Injectable({
  providedIn: 'root',
})
export class RtpTransactionDualApprovalService extends TransactionDualApprovalService {
  override controllerUrl = `/manager/rtp/transactiondualapproval`;
  override urlGetPendingFedNowTransactionApprovalCount = `${environment.apiUrl}${this.controllerUrl}/pendingCount`;
  override urlDecisionedNotificationCountsByStatus = `${environment.apiUrl}${this.controllerUrl}/decisionedNotificationCountsByStatus`;
  override urlDecisionedNotificationCountsByTransactionType = `${environment.apiUrl}${this.controllerUrl}/decisionedNotificationCountsByTransactionTypeAndStatus`;
  override urlClearDecisionedNotifications = `${environment.apiUrl}${this.controllerUrl}/clearDecisionedNotifications`;
  override urlGrid = `${environment.apiUrl}${this.controllerUrl}/grid`;
  override urlGridExportCSV = `${environment.apiUrl}${this.controllerUrl}/gridExportCSV`;
  override urlGridExportExcel = `${environment.apiUrl}${this.controllerUrl}/gridExportExcel`;
  override urlApprove = `${environment.apiUrl}${this.controllerUrl}/approve`;
  override urlDeny = `${environment.apiUrl}${this.controllerUrl}/deny`;
  override urlRfpApprove = `${environment.apiUrl}${this.controllerUrl}/rfp/approve`;
  override urlRfpDeny = `${environment.apiUrl}${this.controllerUrl}/rfp/deny`;
  override urlNoDecision = `${environment.apiUrl}${this.controllerUrl}/nodecision`;

  constructor(http: HttpClient) {
    super(http);
  }
}
